module.exports = "https://payments.pagoefectivo-pre.com/Roboto-Regular.8abc59749b1402658fc37313f99938b7.woff";